<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 900px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-9 pl-0">
            <h3 class="modal-title">
              {{insuranceName}}<span>({{prodId}})</span>
              <a class="text-orange" target="_blank" :href="mainPolicyInfo.URL" style="text-decoration:none">
                <i class="icon-open_as i-20"></i>
              </a>
            </h3>
          </div>
          <div class="col-3 pr-0 text-right">
            <h4 class="my-1">#{{no}}</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="radio radio-inline">
              <input type="radio" name="insurance-content" id="insurance-radio-1" v-model="insuranceContent" value="0">
              <label for="insurance-radio-1">基本資料</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="insurance-content" id="insurance-radio-2" v-model="insuranceContent" value="1">
              <label for="insurance-radio-2">附約明細</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="insurance-content" id="insurance-radio-3" v-model="insuranceContent" value="2">
              <label for="insurance-radio-3">繳費訊息</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="insurance-content" id="insurance-radio-4" v-model="insuranceContent" value="3">
              <label for="insurance-radio-4">保全給付</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" name="insurance-content" id="insurance-radio-6" v-model="insuranceContent" value="5">
              <label for="insurance-radio-6">受益人明細</label>
            </div>
            <div class="radio radio-inline" v-show="isShowNoIdRelationship">
              <input type="radio" name="insurance-content" id="insurance-radio-5" v-model="insuranceContent" value="4">
              <label for="insurance-radio-5">無記名家庭關係</label>
            </div>
            <div class="radio radio-inline" v-show="isLoading_6">
               <span class="loading-block">
                 <br v-show="!isShowNoIdRelationship">
                 <label class="loading-text">外溢保單資訊查詢中，請稍後</label>
               </span>
            </div>
            <div class="radio radio-inline" v-show="is_show_spilloverPolicy">
              <input type="radio" name="insurance-content" id="insurance-radio-7" v-model="insuranceContent" value="6">
              <label for="insurance-radio-7">外溢保單</label>
            </div>
          </div>
          <div v-if="insuranceContent==0"
          :class="{
                'section-loading': isLoading_2
          }">
            <table class="table table-basic">
              <tbody>
                <tr>
                  <th>主約效力</th>
                  <td>{{mainPolicyInfo.EFT_CODE_NM}}</td>
                  <th>投保日期</th>
                  <td>{{mainPolicyInfo.ISSUE_DATE || '— —'}}</td>
                  <th>投保年齡</th>
                  <td>{{mainPolicyInfo.AGE}}</td>
                </tr>
                <tr>
                  <th>被保人</th>
                  <td :key="`insurance-insd-${mainPolicyInfo.INSD_ID}-${prodId}`">{{mainPolicyInfo.INSD_NM}}</td>
                  <th>被保人身分證字號</th>
                  <td>{{mainPolicyInfo.INSD_ID}}</td>
                  <th>被保人生日</th>
                  <td>{{mainPolicyInfo.INSD_BRDY || '— —'}}</td>
                </tr>
                <tr>
                  <th>要保人</th>
                  <td :key="`insurance-apc-${mainPolicyInfo.APC_ID}-${prodId}`">{{mainPolicyInfo.APC_NM}}</td>
                  <th>要保人身分證字號</th>
                  <td>{{mainPolicyInfo.APC_ID}}</td>
                  <th>要保人生日</th>
                  <td>{{mainPolicyInfo.APC_BRDY || '— —'}}</td>
                </tr>
                <tr>
                  <th>招攬單位</th>
                  <td>{{mainPolicyInfo.ACT_DIV_NO}}</td>
                  <th>墊繳表示</th>
                  <td>{{mainPolicyInfo.AUTO_PREM_CODE_CH}}</td>
                  <th>紅利選擇</th>
                  <td>{{mainPolicyInfo.DVD_KIND_CH}}</td>
                </tr>
                <tr>
                  <th>收費代號</th>
                  <td>{{mainPolicyInfo.CLC_NO}}</td>
                  <th>集彙件</th>
                  <td>{{formatIS_GROUP}}</td>
                  <th>體檢</th>
                  <td>{{mainPolicyInfo.MED_EXAM_CH}}</td>                  
                </tr>
                <tr>
                  <th>最近異動日</th>
                  <td>{{formatLST_CHG_DATE}}</td>
                  <th>最近異動種類</th>
                  <td colspan="3">{{mainPolicyInfo.LST_CHG_KIND_CH}}</td>
                </tr>
                <tr>
                  <th>收費電話</th>
                  <td>{{mainPolicyInfo.MOBILE_TEL}}</td>
                  <th>收費地址</th>
                  <td colspan="3">{{mainPolicyInfo.ZIP_CODE}}{{mainPolicyInfo.ADDR}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="insuranceContent==1"
          :class="{
                'section-loading': isLoading_1
          }">
            <table class="table insurance-green">
              <thead>
                <tr>
                  <th>被保險人</th>
                  <th>險種名稱/險種代號</th>
                  <th>契約效力</th>
                  <th class="text-right">保額/計畫</th>
                  <th class="text-right">表訂保費</th>
                  <th>保障終止日</th>
                </tr>
              </thead>
              <tbody v-if="insurDetailList.length">
                <tr
                v-for="(insurance, index) in insurDetailList"
                :key="`insurDetail-list-${index}`"
                >
                  <td width="80">{{insurance.cs_name}}</td>
                  <td width="370">
                    <a class="text-orange float-right" target="_blank" 
                    :href="insurance.product_link"
                    style="text-decoration:none">
                      <i class="icon-open_as i-18"></i>
                    </a>
                    {{insurance.rd_name}}({{insurance.rd_id}}) <div v-if="insurance.job_cat_ch">職業類別：{{insurance.job_cat_ch}}</div>
                  </td>
                  <td width="80">{{insurance.eft_code_ch}}</td>
                  <td width="95" class="text-right">{{insurance.rd_amt | numberFormat}}{{insurance.rdAmtUnit}}</td>
                  <td width="95" class="text-right">{{insurance.rd_prem | numberFormat}}{{insurance.rd_prem_unit}}</td>
                  <td v-if="insurance.term_date && insurance.term_date.indexOf('-') > -1">{{insurance.term_date | dateFormat}}</td>
                  <td v-else>{{insurance.term_date}}</td>
                </tr>
                
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="6">
                    <h3 class="mb-3">無附加附約</h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="insuranceContent==2" :class="{
                'section-loading': isLoading_3
          }">
            <table class="table table-basic">
              <tr>
                <th>繳別</th>
                <td>{{this.PaymentDetail.PAY_FREQ}}</td>
                <th>繳費年期</th>
                <td>{{this.PaymentDetail.PAY_PRD}}</td>
                <th>已繳次數</th>
                <td>{{this.PaymentDetail.PAY_TIMES}}次</td>
              </tr>
              <tr>
                <th>主約表訂保費</th>
                <td>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.MAIN_PREM) | numberFormat}}</td>
                <th>主約高保費折減</th>
                <td>{{this.PaymentDetail.RATE_DISC_H}}%</td>
                <th>主約轉帳折扣</th>
                <td>{{this.PaymentDetail.RATE_DISC_W}}%</td>
              </tr>
              <tr>
                <th>附約表訂保費</th>
                <td>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.PREM_RD) | numberFormat}}</td>
                <th>優待保費</th>
                <td v-if="Number(this.PaymentDetail.PREM_DISC) == 0">0</td>
                <td v-else>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.PREM_DISC) | numberFormat}}</td>
                <th>調整保費</th>
                <td v-if="Number(this.PaymentDetail.PREM_ADJ) == 0">0</td>
                <td v-else>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.PREM_ADJ) | numberFormat}}</td>
              </tr>
              <tr>
                <th>下次應繳保費</th>
                <td>{{this.PaymentDetail.CURR}}{{Number(this.PaymentDetail.PREM_RCPT) | numberFormat}}</td>
                <th>下次繳費日</th>
                <td>{{this.PaymentDetail.NXT_PAY_DATE | dateFormat}}</td>
                <th>墊繳狀態</th>
                <td v-if="Number(this.PaymentDetail.AUTO_PREM_STS) == 1"><span class="text-orange">墊繳中</span></td>
                <td v-else>無</td>
              </tr>
              <tr>
                <th>繳費方式</th>
                <td>{{this.PaymentDetail.PAY_WAY_CODE}}</td>
                <th>銀行名稱</th>
                <td>{{this.PaymentDetail.BANK_NAME}}</td>
                <th>帳/卡號(末四碼)</th>
                <td>{{this.PaymentDetail.ACNT_CARD_NO}}</td>
              </tr>
            </table>

            <h4>近6次繳費記錄</h4>
            <table class="table insurance-green">
              <thead>
                <tr>
                  <th>繳費方式</th>
                  <th>帳/卡號(末四碼)</th>
                  <th class="text-right">繳費金額</th>
                  <th class="text-right">繳次</th>
                  <th class="text-left">繳費日期</th>
                  <th>備註</th>
                </tr>
              </thead>
              <tbody v-if="PaymentRecord.length">
                <tr v-for="(PR, index) in PaymentRecord"
                :key="`insurDetail-list-${index}`">
                  <td>{{PR.PAY_WAY_CODE}}</td>
                  <td v-if="PR.PAY_WAY_CODE && PR.PAY_WAY_CODE.trim() === '轉帳'">{{PR.ACNT_NO_TRN}}</td>
                  <td v-else-if="PR.PAY_WAY_CODE && PR.PAY_WAY_CODE.trim() === '信用卡'">{{PR.CARD_NO}}</td>
                  <td v-else>繳費方式非轉帳與信用卡</td>
                  <td class="text-right">{{Number(PR.TOT_PREM) | numberFormat}}元</td>
                  <td class="text-right">{{PR.PAY_TIMES}}</td>
                  <td>{{PR.PAY_DATE_CLC | dateFormat}}</td>
                  <td></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="6">
                    <h3 class="mb-3">查無資料</h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="insuranceContent==3">
            <h4>保單一指通資訊 :</h4>
            <div :class="{
              'section-loading': isLoading_4
            }">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th style="width:15%">受款人姓名</th>
                    <th style="width:15%">受款人角色</th>
                    <th style="width:15%">給付種類</th>
                    <th>行庫簡稱</th>
                    <th style="width:15%">帳號末四碼</th>
                    <th style="width:15%">備註</th>
                  </tr>
                </thead>
                <tbody v-if="oneInfoList.length">
                  <tr v-for="(oneInfo, index) in oneInfoList"
                  :key="`oneInfo-list-${index}`"
                  >
                    <td>{{oneInfo.bene_name}}</td>
                    <td>{{oneInfo.bene_role}}</td>
                    <td>{{oneInfo.bene_type}}</td>
                    <td>{{oneInfo.bank_simple_name}}</td>
                    <td>{{oneInfo.acnt_no_last4}}</td>
                    <td>{{oneInfo.memo}}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">
                      <h3 class="mb-3">未約定</h3>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h4>近6次給付記錄</h4>
            <div :class="{
              'section-loading': isLoading_4
            }">
              <table class="table insurance-green">
                <thead>
                  <tr>
                    <th>給付方式</th>
                    <th>轉帳帳號(末四碼)</th>
                    <th>給付項目</th>
                    <th class="text-right">給付金額</th>
                    <th>給付日期</th>
                    <th>備註</th>
                  </tr>
                </thead>
                <tbody v-if="payRecordsList.length">
                  <tr v-for="(payRecord, index) in payRecordsList"
                  :key="`payRecords-list-${index}`"
                  >
                    <td>{{payRecord.PAY_KIND_CH}}</td>
                    <td>{{payRecord.ACPT_ACNT_NO}}</td>
                    <td>{{payRecord.TRN_KIND_CH}}</td>
                    <td class="text-right">{{payRecord.RTN_ADD_AMT}}元</td>
                    <td>{{payRecord.ACNT_DATE | dateFormat}}</td>
                    <td></td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">
                      <h3 class="mb-3">無給付紀錄</h3>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="insuranceContent==4 && isShowNoIdRelationship">
            <div class="hint-block">
              新增或編輯無記名家庭關係，「
              <span class="text-red">配偶/子女的保單資訊</span>」須於晚上排程更新後「
              <span class="text-red">明日才會呈現</span>」:
            </div>
            <div class="panel member-item"
            v-for="(mem, mid) in familyMembers"
            :key="`untrack-mem-${mid}`">
              <form class="form" :class="{'is-edit': mem.edit}">
                <div class="no">
                  <span class="text">{{mid+1}}</span>
                </div>
                <div class="name">
                  <div v-if="!mem.edit">
                    <a class="link text-underline">{{mem.cop_name}}</a>
                  </div>
                  <div class="form-group" v-else>
                    <label>姓名</label>
                    <input type="text" class="form-control" v-model="mem.cop_name">
                  </div>
                </div>
                <div class="role">
                  <div v-if="!mem.edit">
                    身份 <b class="ml-1">{{mem.cop_kind==0?'子女':'配偶'}}</b>
                  </div>
                  <div class="form-group" v-else>
                    <label>身份</label>
                    <select class="form-control" v-model="mem.cop_kind">
                      <option value="C">配偶</option>
                      <option value="0">子女</option>
                    </select>
                  </div>
                </div>
                <div class="identity">
                  <div v-if="!mem.new">
                    ID <b class="ml-1">{{mem.cop_id}}</b>
                  </div>
                  <div class="form-group" v-else>
                    <label>ID</label>
                    <input type="text" class="form-control" v-model="mem.cop_id">
                  </div>
                </div>
                <div class="birth">
                  <div v-if="!mem.edit">
                    生日 <b class="ml-1">{{mem.cop_birthday | slashDateFormat}}</b>
                  </div>
                  <div class="form-group" v-else>
                    <label>生日</label>
                    <div class="input-group">
                      <date-picker
                      v-model="mem.cop_birthday"
                      :format="dateFormatter"
                      :language="dateLang"
                      :first-day-of-week="1" />
                    </div>
                  </div>
                </div>
                <div class="action" v-if="!mem.edit">
                  <a class="btn btn-sm btn-text" role="button"
                  @click="toggleEdit(mem, mid)">
                    <i class="icon-edit"></i>
                  </a>
                </div>
                <div class="action" v-else>
                  <a v-if="!mem.new" role="button" class="btn btn-sm btn-default"
                  @click="removeMember(mem)">
                    刪除
                  </a>
                  <a v-if="mem.new" role="button" class="btn btn-sm btn-default"
                  @click="cancelMember()">
                    取消
                  </a>
                  <a v-if="mem.new" role="button" class="btn btn-sm btn-primary"
                  @click="addInsurance(mem, mid)">
                    新增儲存
                  </a>
                  <a v-if="!mem.new" role="button" class="btn btn-sm btn-primary"
                  @click="updateMember(mem, mid)">
                    儲存
                  </a>
                </div>
              </form>
            </div>
            <div class="panel member-item text-center" @click="addFamily()">
              <div class="add">
                <i class="icon-add_new text-orange mr-2"></i>
                <span class="text">新增無記名關係</span>
              </div>
            </div>
          </div>
          <div v-if="insuranceContent==5"
          :class="{
            'section-loading': isLoading_5
          }">
            <table class="table insurance-green">
              <thead>
                <tr>
                  <th>險種名稱/險種代號</th>
                  <th>類別</th>
                  <th>受益人姓名</th>
                  <th>關係</th>
                  <th>受益比例</th>
                  <th>順位</th>
                </tr>
              </thead>
              <tbody v-if="beneficiariesList.length">
                <tr v-for="(item, index) in beneficiariesList"
                :key="`beneficiaries-list-${index}`"
                >
                  <td>{{item.prod_id_ch}}({{item.prod_id}})</td>
                  <td>{{item.bene_type_ch}}</td>
                  <td>{{item.bene_name}}</td>
                  <td>{{item.rltn_ch}}</td>
                  <td>{{item.bene_rato}}%</td>
                  <td>{{item.bene_prio}}</td>
                </tr>
              </tbody>
              <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">
                      <h3 class="mb-3">無受益人明細</h3>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
          <!--外溢保單block-->
          <div v-if="insuranceContent==6">
            <span v-if="is_show_spilloverPolicy && !is_show_spilloverPolicy_under18 && !is_show_spilloverPolicy_under21" class="span-prod-hint-block">外溢保單相關回饋為保戶權益，請務必向保戶說明各商品之外溢機制，並提醒保戶(被保險人)於指定期間完成回饋條件，以確保客戶權益。</span>
            <span v-else-if="is_show_spilloverPolicy_under18" class="span-prod-hint-block">本商品被保險人保險年齡18歲(含)以上，始啟動本商品之健康促進相關回饋，即未滿18歲尚未啟動外溢機制，詳請參考保單契約條款。</span>
            <span v-else-if="is_show_spilloverPolicy_under21" class="span-prod-hint-block">本商品被保險人保險年齡21歲(含)以上，始啟動本商品之健康促進相關回饋，即未滿21歲尚未啟動外溢機制，詳請參考保單契約條款。</span>
              <div v-for="(item, index) in spilloverPolicyList" :key="`div-spillover-policy-${index}`" class="div-spillover-policy">
                <div v-if="item.is_spillover_prod == 'Y' && item.is_show">
                  <br>
                  <span class="span-prod-name-block">{{item.prod_name}}({{item.prod_id}})
                    <a class="text-orange product-hyper-link" target="_blank" :href="item.link_url">
                      <i class="icon-open_as i-20"></i>
                    </a>
                  </span>
                  <br>
                  <span class="span-insd-name-block">被保險人 : {{item.insd_name}}</span>
                  <span v-if="item.is_investment == 'Y'">
                    <br>{{item.feedback_message}}
                  </span>
                  <span v-else-if="item.is_membership == 'Y'" class="span-spillover-start-term-date">
                    次年度外溢回饋判斷日 : {{item.spillover_memstl_date | dateFormat}}
                  </span>
                  <span v-else-if="item.spillover_start_date && item.spillover_term_date" class="span-spillover-start-term-date">
                    外溢回饋計算期間 : {{item.spillover_start_date | dateFormat}} ~ {{item.spillover_term_date | dateFormat}}
                  </span>
                  <!--折減型-->
                  <table v-if="item.is_premium_reduce=='Y'" class="table table-basic">
                    <thead>
                      <tr>
                        <th class="text-left" width="15%">外溢項目</th>
                        <th class="text-left" width="35%">達成狀況</th>
                        <th class="text-left" width="23%">次年度保費回饋%數</th>
                        <th class="text-left" width="27%">備註</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>健走步數</td>
                        <td>{{item.spillover_achieve_times | getAchieveTimes}}</td>
                        <td>{{item.spillover_disc_rate | getPercentNumber}}</td>
                        <td>{{item.is_cwp_member | getCwpText}}</td>
                      </tr>
                      <tr v-if="item.is_health_check == 'Y'">
                        <td>健康檢查</td>
                        <td>{{item.health_check_doc | getUploadStatusText}}</td>
                        <td>{{item.health_check_disc_rate | getPercentNumber}}</td>
                        <td>上傳日: {{item.health_check_update | dateFormat}}</td>
                      </tr>
                      <tr v-if="item.is_cancer_scerrn == 'Y'">
                        <td>癌症篩檢</td>
                        <td v-if="item.is_vaccine == 'Y' && item.is_smoking_cessation == 'Y'" rowspan="3">
                          {{item.spilloverall_doc | getUploadStatusText}}
                        </td>
                        <td v-else-if="item.is_vaccine == 'Y'" rowspan="2">
                          {{item.spilloverall_doc | getUploadStatusText}}
                        </td>
                        <td v-if="item.is_vaccine == 'Y' && item.is_smoking_cessation == 'Y'" rowspan="3">
                          {{item.spilloverall_disc_rate | getPercentNumber}}
                        </td>
                        <td v-else-if="item.is_vaccine == 'Y'" rowspan="2">
                          {{item.spilloverall_disc_rate | getPercentNumber}}
                        </td>
                        <td v-if="item.is_vaccine == 'Y' && item.is_smoking_cessation == 'Y'" rowspan="3">
                          上傳日: {{item.spilloverall_update | dateFormat}}
                        </td>
                        <td v-else-if="item.is_vaccine == 'Y'" rowspan="2">
                          上傳日: {{item.spilloverall_update | dateFormat}}
                        </td>
                      </tr>
                      <tr v-if="item.is_vaccine == 'Y'">
                        <td>疫苗接種</td>
                      </tr>
                      <tr v-if="item.is_smoking_cessation == 'Y'">
                        <td>戒菸治療</td>
                      </tr>
                    </tbody>
                  </table>
                  <!--增額型-->
                  <table v-else-if="item.is_increase_amt=='Y'" class="table table-basic">
                    <thead>
                      <tr>
                        <th class="text-left">外溢項目</th>
                        <th class="text-left">達成狀況</th>
                        <th class="text-left">增額回饋%數</th>
                        <th class="text-left">備註</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>健走步數</td>
                        <td>{{item.spillover_achieve_times | getAchieveTimes}}</td>
                        <td>{{item.spillover_ppo_amt | getPercentNumber}}</td>
                        <td>{{item.is_cwp_member | getCwpText}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!--投資型-->
                  <table v-else-if="item.is_investment=='Y'" class="table table-basic">
                    <thead>
                      <tr>
                        <th class="text-left">外溢項目</th>
                        <th class="text-left">計步優惠</th>
                        <th class="text-left">備註</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>健走步數</td>
                        <td>{{item.trn_item | getTrnItemText}}</td>
                        <td>{{item.is_cwp_member | getCwpText}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!--會員型-->
                  <table v-else-if="item.is_membership=='Y'" class="table table-basic">
                    <thead>
                      <tr>
                        <th class="text-left">外溢項目</th>
                        <th class="text-left">當前CWP會員等級*</th>
                        <th class="text-left">當年度累積會員經驗分*</th>
                        <th class="text-left">次保單年度回饋預估%數*</th>
                        <th class="text-left">備註</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>CWP會員型</td>
                        <td>{{item.cwp_level | getCwpLevelText}}</td>
                        <td>{{item.cwp_exp}}</td>
                        <td>{{item.spillovermem_disc_rate | getPercentNumber}}</td>
                        <td>{{item.is_cwp_member | getCwpText}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <!--其他型-->
                  <span v-else-if="item.is_premium_reduce == 'N' && item.is_increase_amt == 'N' && item.is_investment == 'N'">
                    <br>{{item.feedback_message}}
                  </span>
                  <!--會員型說明區塊-->
                  <p v-if="item.is_membership=='Y'">
                    *註：<br>
                    <table>
                      <tr>
                        <td class="td-align-top">
                          1.&nbsp;&nbsp;
                        </td>
                        <td>
                          會員年度：客戶加入CWP健康計劃之日期起算一年，以加入會員日為週期重新起算。
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top">
                          2.&nbsp;&nbsp;
                        </td>
                        <td>
                          會員等級：客戶於會員年度間累積經驗分，達標後立即升等；本會員年度累積之會員等級，將延續至下一會員年度。(初始等級為一般會員，經驗分達6,000分升等為進階會員，達12,000分升等為菁英會員。)
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top">
                          3.&nbsp;&nbsp;
                        </td>
                        <td>
                          經驗分：每個會員年度累積之經驗分，將於結算日隔日歸零並重新計算。
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top">
                          4.&nbsp;&nbsp;
                        </td>
                        <td>
                          CWP會員等級/經驗分計算案例：110/7/13加入CWP，會員等級及經驗分將於每年7/12結算，經驗分於7/13歸零重新計算；111/7/12結算時若達進階會員資格，111/7/13~112/7/12 會員等級將延續為進階會員。
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top">
                          5.&nbsp;&nbsp;
                        </td>
                        <td>
                          次年度外溢回饋判斷日(指定日期)：為保單週年月前兩個月最後一日(例: 投保始期為110/9/15，次年度外溢回饋判斷日則為111/7/31、112/7/31…以此類推)。
                        </td>
                      </tr>
                      <tr>
                        <td class="td-align-top hint-text">
                          6.&nbsp;&nbsp;
                        </td>
                        <td class="hint-text">
                          次保單年度回饋預估%數：系統以當前CWP會員等級進行預估，實際須以「次年度外溢回饋判斷日」當天之會員等級為準，核算次保單年度之保費折減%數。
                        </td>
                      </tr>
                    </table>
                  </p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker/components/Datepicker";
import { zh } from "@/components/DatePicker/locale";
import { mapGetters } from "vuex";
import { addFamilyRelationOfInsurance } from "@/service";
import { queryFamilyRelationOfInsurance } from "@/service";
import { updateFamilyRelationOfInsurance } from "@/service";
import { deleteFamilyRelationOfInsurance } from "@/service";
import { queryMinorInsurDetail } from "@/service";
import { queryMainPolicyInfo } from "@/service";
import { getInsuDetailPayRecords } from "@/service";
import { queryMainPolicyBeneficiariesInfo } from "@/service";
import { queryPaymentMessage } from "@/service";
import { getSpilloverPolicyForBnk } from "@/service";

export default {
  name: "bkInsuranceModal",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    no: {
      type: String,
      default: "",
    },
    insuranceName: {
      type: String,
      default: "",
    },
    prodId: {
      type: String,
      default: "",
    },
    isShowNoIdRelationship: {
      type: Boolean,
      default: false,
    },
  },
  components: { DatePicker },
  data() {
    return {
      dateLang: zh,
      dateFormatter: (date) => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${date.getFullYear() - 1911}/${(m < 10 ? "0" : "") + m}/${(d <
        10
          ? "0"
          : "") + d}`;
      },
      isLoading_1: false,
      isLoading_2: false,
      isLoading_3: false,
      isLoading_4: false,
      isLoading_5: false,
      isLoading_6: false,
      insuranceContent: 0,
      currentIndex: null,
      currentMember: null,
      bufferMember: null,
      familyMembers: [],
      insurDetailList: [],
      mainPolicyInfo: {},
      payRecordsList: [],
      beneficiariesList: [],
      PaymentDetail: [],
      PaymentRecord: [],
      oneInfoList: [],
      spilloverPolicyList: [], //外溢保單
      is_show_spilloverPolicy: false,
      is_show_spilloverPolicy_under18: false,
      is_show_spilloverPolicy_under21: false
    };
  },
  watch: {
    open: "initData",
    // 難字刷新
    isLoading_1(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_2(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_3(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_4(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    isLoading_5(val) {
      if (!val) {
        this.registerHanlink();
      }
    },
    insuranceContent: function() {
      this.registerHanlink();
    },
  },
  filters: {
    //CWP綁定對照
    getCwpText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "N") {
        text = "未綁定CWP";
      }
      return text;
    },
    //上傳資料狀態對照
    getUploadStatusText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "00") {
        text = "未上傳";
      } else if (val == "01") {
        text = "審核中";
      } else if (val == "02") {
        text = "審核未過，重新上傳";
      } else if (val == "03") {
        text = "已上傳成功";
      }
      return text;
    },
    //達成狀況對照
    getAchieveTimes: function(val) {
      let text = val;
      if (!val || !val.trim() || val.trim() == "00") {
        text = "0";
      }
      return text + "個月";
    },
    //次年度保費回饋%數對照
    getPercentNumber: function(val) {
      if (!val || !val.trim() || val.trim() == "00") {
        return "0%";
      }
      return val + "%";
    },
    //投資型交易項目對照
    getTrnItemText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      } else if (val == "DDL") {
        text = "加值給付";
      } else if (val == "CC4") {
        text = "保險成本折減";
      } else if (val == "HDB") {
        text = "步數達標額外加值給付";
      }
      return text;
    },
    //CWP會員等級
    getCwpLevelText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      } else if (val == "0") {
        text = "未加入CWP";
      } else if (val == "1") {
        text = "初階會員";
      } else if (val == "2") {
        text = "進階會員";
      } else if (val == "3") {
        text = "菁英會員";
      }
      return text;
    },
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    familyMembersCopCheck() {
      // 檢核 無記名關係為配偶的只能有一個
      let hasCop = 0;
      this.familyMembers.forEach((item) => {
        if (item.cop_kind === "C") {
          hasCop += 1;
        }
      });
      return hasCop > 1;
    },
    formatLST_CHG_DATE() {
      // 最近異動日
      if (
        !this.mainPolicyInfo.LST_CHG_DATE ||
        this.mainPolicyInfo.LST_CHG_DATE === "0/01/01"
      ) {
        return "— —";
      } else {
        return this.mainPolicyInfo.LST_CHG_DATE;
      }
    },
    formatIS_GROUP() {
      // 集彙件轉換Y=>是
      if (this.mainPolicyInfo.IS_GROUP === "Y") {
        return "是";
      } else {
        return "否";
      }
    },
  },
  methods: {
    initData(val) {
      this.insuranceContent = "0";
      if (val) {
        this.mounteData();
      }
    },
    getFamilyRelationOfInsurance() {
      //查詢保單無記名家庭關係
      queryFamilyRelationOfInsurance(
        this.$store.state.userInfo.id,
        this.$store.state.custInfo.ID
      ).then((result) => {
        let newDataList = result.body.familymembers;
        newDataList.forEach((item, index) => {
          newDataList[index].edit = false;
          newDataList[index].new = false;
        });
        this.familyMembers = newDataList;
        if (!this.familyMembers) {
          this.familyMembers = [];
        }
      });
    },
    getMainPolicyInfo() {
      //查詢主約基本資料
      this.isLoading_2 = true;
      queryMainPolicyInfo(this.no, this.$store.state.userInfo.id).then(
        (result) => {
          this.mainPolicyInfo = result.body;
          if (!this.mainPolicyInfo) {
            this.mainPolicyInfo = {};
          } else {
            switch (this.mainPolicyInfo.MED_EXAM_CH) {
              case "無體":
                this.mainPolicyInfo.MED_EXAM_CH = "無體檢";
                break;
            }
          }

          this.isLoading_2 = false;
        }
      );
    },
    getPaymentMessage() {
      //查詢繳費訊息
      this.isLoading_3 = true;
      queryPaymentMessage(this.$store.state.userInfo.id, this.no).then(
        (result) => {
          if (result.body.PaymentDetail) {
            this.PaymentDetail = result.body.PaymentDetail;
          } else {
            this.PaymentDetail = [];
          }
          if (result.body.PaymentRecord) {
            this.PaymentRecord = result.body.PaymentRecord;
          } else {
            this.PaymentRecord = [];
          }
          this.isLoading_3 = false;
        }
      );
    },
    getPayRecords() {
      //查詢保全訊息-給付紀錄&已約定的保單一指通資訊
      this.isLoading_4 = true;
      getInsuDetailPayRecords(this.$store.state.userInfo.id, this.no).then(
        (result) => {
          if (result.body.PAY_LIST) {
            this.payRecordsList = result.body.PAY_LIST;
          } else {
            this.payRecordsList = [];
          }

          if (result.body.ONEINFO_LIST) {
            this.oneInfoList = result.body.ONEINFO_LIST.map((item) => {
              let memo = "";
              if (item.RTN_CODE === "1") {
                memo = "請洽服務中心查詢";
              } else if (item.BENE_PRIO && item.BENE_PRIO !== "0") {
                memo = "順位: " + item.BENE_PRIO;
              } else if (item.BENE_RATO && item.BENE_RATO !== "0.00") {
                memo = "比例: " + Math.abs(item.BENE_RATO) + "%";
              }
              return {
                bene_name: item.BENE_NAME,
                bene_role: item.BENE_ROLE,
                bene_type: item.BENE_TYPE,
                bank_simple_name:
                  item.BANK_SIMPLE_NAME !== "" ? item.BANK_SIMPLE_NAME : `— —`,
                acnt_no_last4:
                  item.ACNT_NO_LAST4 === "未約定" ? `— —` : item.ACNT_NO_LAST4,
                memo: memo,
              };
            });
          } else {
            this.oneInfoList = [];
          }

          this.isLoading_4 = false;
        }
      );
    },
    getMainPolicyBeneficiariesInfo() {
      //查詢主約受益人明細
      this.isLoading_5 = true;
      queryMainPolicyBeneficiariesInfo(
        this.$store.state.userInfo.id,
        this.no
      ).then((result) => {
        if (result.body.rider_list) {
          this.beneficiariesList = result.body.rider_list;
        } else {
          this.beneficiariesList = [];
        }
        this.isLoading_5 = false;
      });
    },
    toggleEdit(member, i) {
      this.currentIndex = i;
      this.currentMember = member;
      for (let j = 0; j < this.familyMembers.length; j++) {
        // reset all edit to false
        this.$set(this.familyMembers[j], ["edit"], false);
      }
      this.$set(this.familyMembers[i], ["edit"], true);
    },
    addFamily() {
      if (this.currentIndex !== null) {
        this.familyMembers[this.currentIndex].edit = false;
        this.currentMember = null;
      }
      this.familyMembers.push({
        cop_name: "",
        cop_kind: "",
        id: "",
        cop_birthday: "",
        edit: false,
        new: true,
      });

      this.familyMembers[this.familyMembers.length - 1].edit = true;
      this.currentMember = this.familyMembers[this.familyMembers.length - 1];
    },
    getInsurance() {
      this.isLoading_1 = true;
      queryMinorInsurDetail(this.UserInfo.id, this.no).then((result) => {
        if (result.body.rider_list && result.body.rider_list.length > 0) {
          this.insurDetailList = result.body.rider_list.map((item) => {
            return {
              policy_no: item.POLICY_NO,
              cs_name: item.INSD_NAME,
              eft_code_ch: item.EFT_CODE_CH,
              term_date: item.TERM_DATE,
              rd_name: item.RD_NAME,
              rd_id: item.RD_ID,
              rd_prem: Number(item.RD_PREM),
              rd_prem_unit: "元",
              rd_amt: Number(item.RD_AMT),
              rdAmtUnit: item.RD_AMT_UNIT,
              curr: item.NTD,
              product_link: item.PRODUCT_LINK,
              job_cat_ch: item.JOB_CAT_CH,
            };
          });
          this.isLoading_1 = false;
        } else {
          this.insurDetailList = [];
          this.isLoading_1 = false;
        }
      });
    },
    mounteData() {
      if (this.isShowNoIdRelationship) {
        this.getFamilyRelationOfInsurance();
      }
      this.getMainPolicyInfo();
      this.getPaymentMessage();
      this.getPayRecords();
      this.getInsurance();
      this.getMainPolicyBeneficiariesInfo();
      this.getSpilloverPolicy();
    },
    removeMember(member) {
      let cop_id = member.cop_id;
      deleteFamilyRelationOfInsurance(
        this.$store.state.userInfo.id,
        this.$store.state.custInfo.ID,
        cop_id
      ).then((result) => {
        if (result.header.status && result.header.status == "200") {
          this.$toast.info({ title: result.header.message });
          this.getFamilyRelationOfInsurance();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    cancelMember() {
      this.familyMembers.pop();
    },
    getChineseDateFormate(cop_birthday) {
      if (cop_birthday !== null && cop_birthday !== "") {
        let dt = window.moment(cop_birthday);
        let m = dt.month() + 1 < 10 ? `0${dt.month() + 1}` : dt.month() + 1;
        let d = dt.date() < 10 ? `0${dt.date()}` : dt.date();
        return `${dt.year() - 1911}/${m}/${d}`;
      } else {
        return "";
      }
    },
    addInsurance(mem) {
      // 在頁面上需檢核 關係為配偶的只能有一個
      if (this.familyMembersCopCheck && mem.cop_kind === "C") {
        return this.$toast.info({
          title: "關係為配偶的客戶僅能一位 ! 請重新確認客戶之關係 !",
        });
      }

      let cop_id = mem.cop_id;
      let name = mem.cop_name;
      let dt = mem.cop_birthday;
      let kind = mem.cop_kind;
      let idRegex = /^[A-Z]{1}[0-9]{9}$/;
      if (idRegex.test(cop_id) && dt !== "") {
        //驗證ID 格式 以及不能為空值
        let dm = (dt.getMonth() + 1 < 10 ? "0" : "") + (dt.getMonth() + 1);
        let dd = (dt.getDate() < 10 ? "0" : "") + dt.getDate();
        let birthday = `${dt.getFullYear() - 1911}${dm}${dd}`; //等民國生日套件完成再修改
        addFamilyRelationOfInsurance(
          this.$store.state.userInfo.id,
          this.$store.state.custInfo.ID,
          cop_id,
          name,
          birthday,
          kind
        ).then((result) => {
          if (result.header.status && result.header.status == "200") {
            this.$toast.info({ title: result.header.message });
            this.getFamilyRelationOfInsurance();
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      } else {
        this.$toast.info({ title: "ID格式不符 或 資料欄位不得為空值" });
      }
    },
    updateMember(member) {
      // 在頁面上需檢核 關係為配偶的只能有一個
      if (this.familyMembersCopCheck && member.cop_kind === "C") {
        return this.$toast.info({
          title: "關係為配偶的客戶僅能一位 ! 請重新確認客戶之關係 !",
        });
      }

      var birthday;
      if (typeof member.cop_birthday == "object") {
        let dt = member.cop_birthday;
        let dm = (dt.getMonth() + 1 < 10 ? "0" : "") + (dt.getMonth() + 1);
        let dd = (dt.getDate() < 10 ? "0" : "") + dt.getDate();
        birthday = `${dt.getFullYear() - 1911}${dm}${dd}`; //等民國生日套件完成再修改
      } else {
        birthday = member.cop_birthday;
      }
      let cop_id = member.cop_id;
      let name = member.cop_name;
      let kind = member.cop_kind;
      updateFamilyRelationOfInsurance(
        this.$store.state.userInfo.id,
        this.$store.state.custInfo.ID,
        cop_id,
        name,
        birthday,
        kind
      ).then((result) => {
        if (result.header.status && result.header.status == "200") {
          this.$toast.info({ title: result.header.message });
          this.getFamilyRelationOfInsurance();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //取得外溢保單資訊
    getSpilloverPolicy() {
      this.isLoading_6 = true;
      this.is_show_spilloverPolicy = false;
      this.is_show_spilloverPolicy_under18 = false;
      this.is_show_spilloverPolicy_under21 = false;
      getSpilloverPolicyForBnk(this.$store.state.userInfo.id, this.no).then(
        (result) => {
          this.isLoading_6 = false;
          if (result.header && result.header.status == "200") {
            this.spilloverPolicyList = result.data || [];
            this.spilloverPolicyList.forEach((item) => {
              if (item.is_spillover_prod == "Y") {
                //只要有一筆資料是外溢保單，就要顯示外溢保單區塊和標語
                this.is_show_spilloverPolicy = true;
              }
              if (item.is_show_under18) {
                //只要有一筆資料符合顯示條件，就顯示客戶小於18歲以下的標語
                this.is_show_spilloverPolicy_under18 = true;
              }
              if (item.is_show_under21) {
                //只要有一筆資料符合顯示條件，就顯示客戶小於21歲以下的標語
                this.is_show_spilloverPolicy_under21 = true;
              }
            });
          } else {
            this.spilloverPolicyList = [];
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  cursor: none;
}
.hint-block {
  padding-bottom: 15px;
  font-weight: 600;
}
.div-spillover-policy {
  padding-bottom: 1%;
}
.span-prod-hint-block {
  font-size: 20px;
}
.span-prod-name-block {
  font-size: 20px;
  font-weight: 600;
}
.span-insd-name-block {
  font-size: 18px;
}
.span-spillover-start-term-date {
  font-size: 18px;
  padding-left: 5%;
}
.product-hyper-link {
  text-decoration: none;
}
.loading-block {
  background-image: url(/crm/assets/common/ajax-loader.gif);
  background-repeat: no-repeat;
  opacity: 0.8;
}
.loading-text {
  padding-left: 27px;
}
.td-align-top {
  vertical-align: top;
}
.hint-text {
  font-weight: 600;
  color: red;
}
</style>
